export const SEARCH_AREA_HEIGHT = 16 + 48;
export const LISTBOX_MIN_HEIGHT = 100 + 16;
export const LISTBOX_MIN_WIDTH = 260;
export const FOOTER_HEIGHT = 48;
